export default __webpack_public_path__ + "static/media/avatar-normal-geometric-20.26ea6dc1.svg";